import { Form, Input, ModalProps, FormProps, Modal, InputNumber, useSelect, Select, Typography, useTable, useForm } from '@pankod/refine-antd'
import { useGetIdentity, useShow } from '@pankod/refine-core'
import { useUserContext } from 'context/user'
import { createUserHistory } from 'gql/mutations'
import { SearchBloomLevelDuplicate } from 'gql/query'
import { IBloomLevel, IGradeLevel, IMedium } from 'interfaces'
import { useEffect, useState } from 'react'

type CreateBloomLevelProps = {
  modalProps: ModalProps
  formProps: FormProps
  record: any
}

export const EditBloomLevels: React.FC<CreateBloomLevelProps> = ({ modalProps, formProps, record }) => {
  const { data: user } = useGetIdentity()
  const { userRole } = useUserContext()
  const metaData = {
    fields: ['id', 'name', 'order', 'created_at'],
  }

  //   const { data: testTrackListData } = useList({ resource: 'test_tracks', metaData: { fields: ['id', 'grade_ids'] } })

  const [error, setError] = useState(false)
  //   const [type, setType] = useState('')
  //   const [order, setOrder] = useState<number>(0)
  const [data, setData] = useState([] as any[])
  const onFinish = async (values: any) => {
    console.log({ values })
    if (!error) {
      return (
        formProps?.onFinish &&
        formProps?.onFinish({
          ...values,
        })
      )
    }
  }
  // useEffect(() => {
  //   SearchBloomLevelDuplicate().then((resp: any) => {
  //     setData(resp?.blooms_levels)
  //     // console.log(resp?.bloom_levels[0]?.order+1)
  //     //   setOrder(parseInt(resp?.blooms_levels?.[0]?.order + 1))
  //   })
  // }, [])
  const checkDuplicates = async (text: any) => {
    console.log(text)
    SearchBloomLevelDuplicate(parseInt(text)).then((resp: any) => {
      // console.log({ resp?.blooms_levels })
      if (resp?.blooms_levels?.length > 0) {
        setError(true)
      } else {
        setError(false)
      }
    })


  }
  // const checkDuplicates = async (text: any) => {
  //   console.log(text)
  //   const result = data?.filter((elem: IBloomLevel) => {
  //     if (parseInt(text) !== record?.order) {
  //       return elem?.order === parseInt(text)
  //     }
  //   })

  //   if (result?.length > 0) {
  //     setError(true)
  //   } else {
  //     setError(false)
  //   }
  //   // setName(text)
  //   // console.log({ result })
  // }
  // console.log({ record })
  return (
    <Modal
      {...modalProps}
      title="Edit Bloom's Level"
      okButtonProps={{
        hidden: error,
        onClick: formProps?.form?.submit,
      }}
    >
      <Form {...formProps} size="large" layout="vertical" onFinish={async values => {
        let response = await onFinish(values).then((response: any) => {
          if (response) {
            createUserHistory('blooms_levels', 'edit', response?.data?.id, user?.id, userRole)
          }

        })

        return response
      }}>
        {/* <Form.Item
          label="Medium"
          name="medium_id"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Select {...mediumSelectProps} />
        </Form.Item> */}
        <Form.Item
          label="Name"
          name="name"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Order"
          name="order"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input type="number" onChange={e => checkDuplicates(e?.target?.value)} />
        </Form.Item>
        <Form.Item name="updated_by" initialValue={user?.id}>
          <Input type="hidden" />
        </Form.Item>
        {error ? <Typography.Text type="danger">Duplicate Found..Please enter another order</Typography.Text> : null}
      </Form>
    </Modal>
  )
}
